import { Avatar, Button, Tag } from "@pinkyhead/dovekit"
import { useParticipationCardDoctor } from "./ParticipationCardDoctor.hooks"
import { ParticipationCardDoctorProps } from "./ParticipationCardDoctor.interface"
import { Container, DetailsContainer } from "./ParticipationCardDoctor.styles"

export const ParticipationCardDoctor = ({ data }: ParticipationCardDoctorProps) => {
  const { redirectTo } = useParticipationCardDoctor(data);
  return (
    <Container>
      <div className="padding">
        <Avatar 
          displayName={data.name}
          size={70}
          fontSize={16}
          picture={data.picture || null}
        />
      </div>
      <div className="divider"></div>
      <DetailsContainer className="padding">
        <p className="displayName">{data.name}</p>
        <Tag name={data.speciality} />
        <p className="answers">Answered Questions: {data.answersCount}</p>
        <Button
          size="small"
          variant="text"
          onClick={redirectTo}
        >
          View Profile
        </Button>
      </DetailsContainer>
    </Container>
  )
}
